import { render, staticRenderFns } from "./credentials.vue?vue&type=template&id=65d7098f&scoped=true"
import script from "./credentials.vue?vue&type=script&lang=js"
export * from "./credentials.vue?vue&type=script&lang=js"
import style0 from "./credentials.vue?vue&type=style&index=0&id=65d7098f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d7098f",
  null
  
)

export default component.exports